module.exports = __webpack_public_path__ + "static/media/md-download.96051207.svg";